import React from "react";
import { DateRangePicker } from "rsuite";
import "../../assets/css/rsuit.css";
import moment from "moment";

const DateTimeRange = ({ setStartDate, setEndDate,startDate,endDate }) => {
  // console.log(moment(moment().startOf("month")).format("MM-DD-YYYY"));
  // console.log(moment(moment().endOf("month")).format("MM-DD-YYYY"));
  // console.log(startDate)
  const currentDate = new Date();

   // Calculate the first day of the current month
   const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  
   // Calculate the last day of the current month
   const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  return (
    <div>
      <DateRangePicker
        // format="yyyy-MM-dd hh:mm aa"
        // showMeridian
        // defaultCalendarValue={[
        //   new Date("2022-02-01 00:00:00"),
        //   new Date("2022-05-01 23:59:59"),
        // ]}
        onChange={(e) => {
          if (e !== null) {
            setStartDate(e[0]);
            setEndDate(e[1]);
          } else {
            setStartDate("");
            setEndDate("");
          }
        }}
        format="MM-dd-yyyy"
        showMeridian
        // defaultCalendarValue={[new Date("08-01-2023"), new Date("09-30-2023")]}
        defaultCalendarValue={[firstDayOfMonth, lastDayOfMonth]} // Current month's range
        ranges={[
          {
            label: "Next 7 Days",
            value: [currentDate, moment(currentDate).add(7, "days").toDate()],
          },
          {
            label: "Next 30 Days",
            value: [currentDate, moment(currentDate).add(30, "days").toDate()],
          },
        ]}
        disabledDate={(date) => date < currentDate} // Disable dates before the current date
        // defaultCalendarValue={[
        //   startDate, endDate]}

        // defaultCalendarValue={[
        //   moment(moment().startOf("month")).format("MM-DD-YYYY"),
        //   moment(moment().endOf("month")).format("MM-DD-YYYY"),
        // ]}
        // // defaultCalendarValue={[new Date("02-01-2022"), new Date("05-01-2022")]}
      />
    </div>
  );
};

export default DateTimeRange;
